import crud from '@/crud/form/form'

import data from './data'
import methods from './methods'
import mounted from './mounted'

export default {
  data,
  methods,
  mounted,

  mixins: [crud],

  resourcePath: 'v1/professional/schedules/next/patient'
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/next-patient/resources/index.js